<template>
  <div ref="newsCont">
    <div class="news">
      <div class="banner">
        <h3>
          <em>X</em>
          <i>联网动态</i>
        </h3>
        <p>见证每一次的改变</p>
      </div>
      <div class="newsList">
        <ul>
          <li
            class="clear"
            :key="i"
            v-for="(item,i) in tableData"
            @click="$router.push('/news/newsDetail/'+item.id)"
          >
            <div class="left">
              <div class="title van-multi-ellipsis--l2">{{item.summary}}</div>
              <div class="desc">
                <em>{{item.addTime1}}</em>
              </div>
            </div>
            <img class="right" v-if="item.imgs && item.imgs.length > 0" :src="item.imgs[0]" alt />
          </li>
        </ul>
        <div class="text-center loading">
          <p v-if="!finish&&!loading" class="gray_b1" @click="loadMore">点击加载更多</p>
          <div v-if="loading">
            <van-loading class="mar_auto" type="spinner" color="#b1b1b1" />
            <p class="gray_b1">正在加载中</p>
          </div>
          <p v-if="finish && tableData.length" class="gray_b1">没有更多</p>
        </div>
      </div>

      <div id="d_footer" class="d_footer">
        <h3 id="fixedDom">欢迎垂询</h3>
        <p class="desc">欢迎关注官方微信“数说产业互联网”，阅读更多精彩文章。也可以扫描下方二维码添加关注。数说产业互联网将为您提供更多解决方案</p>
        <ul class="cont clear">
          <li>
            <div class="mask">
              <div class="desc">
                <p>乡村振兴数字化解决方案</p>
                <div class="link" @click="routerLink('/solution/0')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_01.png" alt />
          </li>
          <li>
            <div class="mask">
              <div class="desc">
                <p>农业单品行业大数据解决方案</p>
                <div class="link" @click="routerLink('/solution/1')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_02.png" alt />
          </li>
          <li>
            <div class="mask">
              <div class="desc">
                <p>农业链主企业数字 化解决方案</p>
                <div class="link" @click="routerLink('/solution/2')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_03.png" alt />
          </li>
          <li>
            <div class="mask">
              <div class="desc">
                <p>现代农业产业园数 字化解决方案</p>
                <div class="link" @click="routerLink('/solution/3')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_04.png" alt />
          </li>
          <li>
            <div class="mask">
              <div class="desc">
                <p>农产品区域公用品牌数字化解决方案</p>
                <div class="link" @click="routerLink('/solution/4')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_05.png" alt />
          </li>
          <li>
            <div class="mask">
              <div class="desc">
                <p>农产品批发市场/交易中心数字化解决方案</p>
                <div class="link" @click="routerLink('/solution/5')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_06.png" alt />
          </li>
        </ul>
      </div>
      <bottom-dialog :isFixed="isF"></bottom-dialog>
    </div>
  </div>
</template>

<script>
import bottomDialog from "./components/bottomDialog.vue";

export default {
  components: {
    bottomDialog: bottomDialog,
  },
  data() {
    return {
       pagination: {
        pageNum: 1,
        pageSize: 10
      },
      finish: false,
      loading: true,
      headerH: 0,
      footerH: 0,
      fixedH: 0,

      isF: true,
      tableData: [],
      scrollHandles: null,
    };
  },
  mounted() {
    this.loadData();
    this.loadStatic();
     this.isFixed();
    this.scrollHandles = () => {
      this.isFixed();
    };
    document.addEventListener("scroll", this.scrollHandles, false);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollHandles, false);
  },
  methods: {
    routerLink(url) {
      this.$router.push(url);
    },
    loadStatic() {
      this.headerH = document.getElementById("mob_header").offsetHeight;
      this.fixedH = document.getElementById("fixedDom").offsetHeight;
      this.footerH = document.getElementById("d_footer").offsetHeight;
    },
    isFixed() {
      // 获取视口高度
      let viewH =
        document.documentElement.clientHeight || document.body.clientHeight;
      let domH = this.$refs["newsCont"].clientHeight;
      let scrollY = window.scrollY;
      let isF =
        scrollY + viewH <= domH + this.headerH - this.footerH + this.fixedH;
      this.isF = isF;
    },
    loadMore() {

        this.loadStatic();
        this.isFixed();
        this.loadData();
    },

    loadData() {
      if(!this.finish) {
      this.loading = true
      this.$store
        .dispatch("api/selContentList", {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          concludeImage: '1',
          tagNames: 'X联网,X联网动态'
        })
        .then(response => {
          this.loading = false
          if(response && response.list && response.list.length > 0) {
            this.pagination.pageNum ++
            this.tableData.push(...response.list)
            if(this.tableData.length >= response.total) {
              this.finish = true
            }
          }else {
            if( response&&response.total==0) {
               this.finish = true
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });}
    }
  },
};
</script>

<style lang="scss">
@import "~@/assets/mob/css/news.scss";
</style>